export default {
	'report-current-store': {
		id: 'report-current-store',
		label: '当前库存查询',
		code: '0008_0001'
	}
}
